import { createFileRoute, useSearch } from '@tanstack/react-router';
import type { JSX } from 'react';

import { CodeQualityDashboard } from '@/features/code-quality/CodeQualityDashboard.js';
import { parseDashboardSearch } from '@/features/code-quality/dashboard-search.js';
import { ensureCodeQualityEnabled } from '@/features/code-quality/guard.js';
import { ensureDashboardsEnabled } from '@/features/dashboards/guard.js';

/**
 * The Code Quality overview in Dashboards: every project the reader may read, across workspaces.
 * The static segment outranks `/dashboards/$id`. `?portfolio=<key>&account=<key>` is the level the
 * overview is drilled into. It opens only while Dashboards and the fail-closed Code Quality flag
 * are both on. The Code Quality guard runs first because it reloads the runtime config, so the
 * Dashboards check reads the fresh one.
 */
export const Route = createFileRoute('/dashboards/code-quality')({
  validateSearch: parseDashboardSearch,
  beforeLoad: async () => {
    await ensureCodeQualityEnabled();
    ensureDashboardsEnabled();
  },
  component: CodeQualityDashboardRoute,
});

function CodeQualityDashboardRoute(): JSX.Element {
  const level = useSearch({ from: '/dashboards/code-quality' });
  return <CodeQualityDashboard level={level} />;
}
